import React from 'react';
import { Callout } from "src/components";
import { ExchangeType, SessionFieldsFragment } from 'src/data';

export function PlanCallouts({ loading, session, showOffExchange, limitedPlanData }: { loading: boolean, partner?: string; session?: SessionFieldsFragment; showOffExchange?: boolean; limitedPlanData?: boolean }) {

  const callouts = [
    {
      id: 'off-exchange-banner',
      imageSrc: "/iconic/shield.svg",
      title: "We're showing you off-exchange plans right now.",
      text: "Because your employer is offering you an ICHRA, these plans can be paid for with tax-free money from your employer. Keep in mind - these plans don't qualify for government subsidies.",
      visible: showOffExchange && session?.exchangeType === ExchangeType.OffMarket,
    },
    {
      id: 'on-exchange-banner',
      bg: "var(--c-orange-1)",
      imageSrc: "/iconic/shield-warning.svg",
      title: "You're looking at on-exchange plans right now.",
      text: "Because your employer is offering you an ICHRA, we recommend considering an off-exchange plan.",
      visible: showOffExchange && session?.exchangeType === ExchangeType.OnMarket
    },
    {
      id: 'limited-plan-data',
      bg: "var(--c-orange-1)",
      imageSrc: "/iconic/shield-warning.svg",
      title: "More plans to come, check back soon",
      text: "Not all carriers have released plans in your state",
      visible: limitedPlanData,
    }
  ].filter(item => item.visible);


  if (loading || callouts.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: 24 }}>
      {callouts.map(callout => (
        <Callout
          key={callout.id}
          smallText
          imageSrc={callout.imageSrc}
          bg={callout.bg}
          title={callout.title}
          text={callout.text}
        />
      ))}
    </div>
  );
}
